import { render, staticRenderFns } from "./LinkQR035.vue?vue&type=template&id=2204e647&scoped=true&"
import script from "./LinkQR035.vue?vue&type=script&lang=js&"
export * from "./LinkQR035.vue?vue&type=script&lang=js&"
import style0 from "./LinkQR035.vue?vue&type=style&index=0&id=2204e647&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2204e647",
  null
  
)

export default component.exports